import Container from '@mui/material/Container';
import { useLocation } from 'react-router-dom';
const BASE_NAME = process.env.REACT_APP_BASE_NAME;

function ErrorPage() {
  const location = useLocation();
  if(!window.localStorage.getItem('token') && !location.pathname.includes("signup"))
    window.location.href = `${BASE_NAME}/login`;
  // let error = useRouteError();
  return <Container maxWidth="xl">
    <div style={{width: '100%', textAlign: 'center'}}>
      <h1>PAGE NOT FOUND</h1>
    </div>
  </Container>
}
export default ErrorPage;